export default __webpack_public_path__ + "img/rectangle.57218188.svg";